import { useRecoilState } from 'recoil';
import roomDetailState, { PickType } from '../../atoms/roomDetail';
import './Picks.scoped.scss';

function Picks() {
  const [roomDetail] = useRecoilState(roomDetailState);

  const pickComponents = roomDetail.pickHistory.map(
    (pickHistoryItem, index) => {
      try {
        const splitedDate = pickHistoryItem.date.split('-');
        const month = splitedDate[1];
        const day = splitedDate[2];
        return (
          <div className="picks__history-item" key={index}>
            <div className="picks__history-item__round-section">
              <div>
                {month}월 {day}일
              </div>
              <div>{pickHistoryItem.round}회</div>
            </div>
            <div className="picks__history-item__balls-section">
              <div>
                {(result => {
                  if (result === '') {
                    return <div className="picks__waiting-ball">대기</div>;
                  } else {
                    const [
                      powerballNumber,
                      powerballOddEvenPick,
                      powerballUnderOverPick,
                      sumNumber,
                      sumOddEvenPick,
                      sumUnderOverPick,
                      sumHighLowPick
                    ] = result.split('|');
                    if (
                      powerballOddEvenPick == null ||
                      powerballUnderOverPick == null ||
                      sumOddEvenPick == null ||
                      sumUnderOverPick == null ||
                      sumHighLowPick == null
                    ) {
                      return <div />;
                    }
                    return (
                      <div className="chatting-pick-symbol__pick">
                        <div>
                          <div
                            className={`chatting-pick-symbol__pick__powerballOddEvenPick ${(pick => {
                              switch (pick) {
                                case '홀':
                                  return 'blue';
                                case '짝':
                                  return 'red';
                                default:
                                  return '';
                              }
                            })(powerballOddEvenPick)}`}
                          >
                            {powerballOddEvenPick}
                          </div>
                          <div
                            className={`chatting-pick-symbol__pick__powerballUnderOverPick ${(pick => {
                              switch (pick) {
                                case '언더':
                                  return 'blue';
                                case '오버':
                                  return 'red';
                                default:
                                  return '';
                              }
                            })(powerballUnderOverPick)}`}
                          >
                            {powerballUnderOverPick.substring(0, 1)}
                          </div>
                        </div>
                        <div>
                          <div
                            className={`chatting-pick-symbol__pick__sumOddEvenPick ${(pick => {
                              switch (pick) {
                                case '홀':
                                  return 'blue';
                                case '짝':
                                  return 'red';
                                default:
                                  return '';
                              }
                            })(sumOddEvenPick)}`}
                          >
                            {sumOddEvenPick}
                          </div>
                          <div
                            className={`chatting-pick-symbol__pick__sumUnderOverPick ${(pick => {
                              switch (pick) {
                                case '언더':
                                  return 'blue';
                                case '오버':
                                  return 'red';
                                default:
                                  return '';
                              }
                            })(sumUnderOverPick)}`}
                          >
                            {sumUnderOverPick.substring(0, 1)}
                          </div>
                        </div>
                        <div
                          className={`chatting-pick-symbol__pick__sumHighLowPick-${(pick => {
                            switch (pick) {
                              case '대':
                                return 'high';
                              case '중':
                                return 'middle';
                              case '소':
                                return 'low';
                              default:
                                return 'none';
                            }
                          })(sumHighLowPick)}`}
                        >
                          {sumHighLowPick}
                        </div>
                      </div>
                    );
                  }
                })(pickHistoryItem.result)}
              </div>
              <div>
                {(pick => {
                  if (pick === '') {
                    return <div className="picks__waiting-ball">선택안함</div>;
                  } else if (pick === 'p') {
                    return <div className="picks__waiting-ball">개설전</div>;
                  } else {
                    const [
                      powerballOddEvenPick,
                      powerballUnderOverPick,
                      sumOddEvenPick,
                      sumUnderOverPick,
                      sumHighLowPick
                    ] = pick.split('|');
                    if (pick.split('|').length !== 5) {
                      return <div />;
                    }
                    return (
                      <div className="chatting-pick-symbol__pick">
                        <div>
                          <div
                            className={`chatting-pick-symbol__pick__powerballOddEvenPick ${(pick => {
                              switch (pick) {
                                case '홀':
                                  return 'blue';
                                case '짝':
                                  return 'red';
                                default:
                                  return '';
                              }
                            })(powerballOddEvenPick)}`}
                          >
                            {powerballOddEvenPick}
                          </div>
                          <div
                            className={`chatting-pick-symbol__pick__powerballUnderOverPick ${(pick => {
                              switch (pick) {
                                case '언더':
                                  return 'blue';
                                case '오버':
                                  return 'red';
                                default:
                                  return '';
                              }
                            })(powerballUnderOverPick)}`}
                          >
                            {powerballUnderOverPick.substring(0, 1)}
                          </div>
                        </div>
                        <div>
                          <div
                            className={`chatting-pick-symbol__pick__sumOddEvenPick ${(pick => {
                              switch (pick) {
                                case '홀':
                                  return 'blue';
                                case '짝':
                                  return 'red';
                                default:
                                  return '';
                              }
                            })(sumOddEvenPick)}`}
                          >
                            {sumOddEvenPick}
                          </div>
                          <div
                            className={`chatting-pick-symbol__pick__sumUnderOverPick ${(pick => {
                              switch (pick) {
                                case '언더':
                                  return 'blue';
                                case '오버':
                                  return 'red';
                                default:
                                  return '';
                              }
                            })(sumUnderOverPick)}`}
                          >
                            {sumUnderOverPick.substring(0, 1)}
                          </div>
                        </div>
                        <div
                          className={`chatting-pick-symbol__pick__sumHighLowPick-${(pick => {
                            switch (pick) {
                              case '대':
                                return 'high';
                              case '중':
                                return 'middle';
                              case '소':
                                return 'low';
                              default:
                                return 'none';
                            }
                          })(sumHighLowPick)}`}
                        >
                          {sumHighLowPick}
                        </div>
                      </div>
                    );
                  }
                })(pickHistoryItem.pick)}
              </div>
            </div>
            <div className="picks__history-item__result-section">
              {((result, pick) => {
                if (result === '' || pick === '' || pick === 'p') {
                  return <div />;
                } else {
                  let winCount = 0;
                  let loseCount = 0;

                  const [
                    powerballNumberResult,
                    powerballOddEvenResult,
                    powerballUnderOverResult,
                    sumNumberResult,
                    sumOddEvenResult,
                    sumUnderOverResult,
                    sumHighLowResult
                  ] = result.split('|');

                  if (
                    powerballOddEvenResult == null ||
                    powerballUnderOverResult == null ||
                    sumOddEvenResult == null ||
                    sumUnderOverResult == null ||
                    sumHighLowResult == null
                  ) {
                    return <div />;
                  }

                  const [
                    powerballOddEvenPick,
                    powerballUnderOverPick,
                    sumOddEvenPick,
                    sumUnderOverPick,
                    sumHighLowPick
                  ] = pick.split('|');

                  if (pick.split('|').length !== 5) {
                    return <div />;
                  }

                  if (powerballOddEvenPick !== '') {
                    if (powerballOddEvenResult === powerballOddEvenPick) {
                      winCount++;
                    } else {
                      loseCount++;
                    }
                  }

                  if (powerballUnderOverPick !== '') {
                    if (powerballUnderOverResult === powerballUnderOverPick) {
                      winCount++;
                    } else {
                      loseCount++;
                    }
                  }

                  if (sumOddEvenPick !== '') {
                    if (sumOddEvenResult === sumOddEvenPick) {
                      winCount++;
                    } else {
                      loseCount++;
                    }
                  }

                  if (sumUnderOverPick !== '') {
                    if (sumUnderOverResult === sumUnderOverPick) {
                      winCount++;
                    } else {
                      loseCount++;
                    }
                  }

                  if (sumHighLowPick !== '') {
                    if (sumHighLowResult === sumHighLowPick) {
                      winCount++;
                    } else {
                      loseCount++;
                    }
                  }

                  return (
                    <>
                      <span style={{ color: '#cd1212' }}>{winCount}승</span>
                      &nbsp;
                      <span style={{ color: '#1265cd' }}>{loseCount}패</span>
                    </>
                  );
                }
              })(pickHistoryItem.result, pickHistoryItem.pick)}
            </div>
          </div>
        );
      } catch (err) {
        console.error(err);
        return <div />;
      }
    }
  );

  return (
    <div className="picks">
      <div className="picks__header">방장픽 정보</div>
      <div className="picks__contents">{pickComponents}</div>
    </div>
  );
}

export default Picks;
